import { Box, Flex, Grid, GridItem, Image, Input, InputGroup, InputLeftElement, Select, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from "@chakra-ui/react";
import MyDiv from "./jobProfile.style";
import { ChevronDownIcon, Search2Icon } from "@chakra-ui/icons";
import { AlertCard, CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../../components";
import { useEffect, useState } from "react";
import addIcon from '../../../../../assets/images/Vector.svg'
import { IJobProfile } from "./Model";
import { useFetch } from "../../../../../hooks/useFetch";
import { Column } from "../../../../../components/CustomTable/customTable";

const JobProfile = () => {
  const [employees, setEmployees] = useState<any[]>([]);
  const [departments, setDepartments] = useState<any[]>([]);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentJobProfile, setCurrentJobProfile] = useState({ id: 0, jobProfile: "", departementName: "", departmentId: 0, status: true, });
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [statusChangeSource, setStatusChangeSource] = useState<"table" | "drawer" | null>(null);

  useEffect(() => {
    loadJobProfile();
    loadDepartments();
  }, []);


  const loadJobProfile = async () => {
    const response = await fetchApi<IJobProfile[]>("Hrlense_JobProfile", "GET");
    if (response) setEmployees(response);
  };

  const loadDepartments = async () => {
    try {
      const response = await fetchApi<any>("DropDown/department", "GET");
      setDepartments(response);
    } catch (error) {
      console.error("Failed to load departments:", error);
      setDepartments([]);
    }
  };

  const handleDepartmentChange = (e: any) => {
    const departmentId = parseInt(e.target.value);
    const selectedDepartment = departments.find(dept => dept.id === departmentId);

    setCurrentJobProfile(prev => ({
      ...prev,
      departmentId: departmentId,
      departementName: selectedDepartment ? selectedDepartment.departmentName : "",
    }));
  };

  const handleStatusChange = (id: number, newStatus: boolean) => {
    setSelectedId(id);
    setPendingStatus(newStatus);
    setStatusChangeSource("table");
    setAlertOpen(true);
  };

  const handleDrawerStatusChange = (newStatus: boolean) => {
    setPendingStatus(newStatus);
    setStatusChangeSource("drawer");
    setAlertOpen(true);
  };

  const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const scoreId = statusChangeSource === "table" ? selectedId : currentJobProfile.id;

      const response = await fetchApi(`Hrlense_JobProfile/toggleStatus/${scoreId}`, "PUT", { id: scoreId, status: pendingStatus }, null, "JobProfile updated successfully");
      if (response) {
        if (statusChangeSource === "table") {
          setEmployees((prev) => prev.map((employees) => employees.id === selectedId ? { ...employees, status: pendingStatus } : employees));
        } else {
          setCurrentJobProfile((prev) => ({ ...prev, status: pendingStatus }));
        }
      }
    }
    setAlertOpen(false);
  };

  const handleAddNewJobProfile = () => {
    setIsEditMode(false);
    setCurrentJobProfile({ id: 0, jobProfile: "", departementName: "", departmentId: 0, status: true, });
    setDrawerOpen(true);
  };

  const handleEditJobProfile = (jobProfile: IJobProfile) => {
    setIsEditMode(true);
    setSelectedId(jobProfile.id);
    setCurrentJobProfile(jobProfile);
    setDrawerOpen(true);
  };
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    setCurrentJobProfile(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async () => {
    if (!currentJobProfile.jobProfile.trim()) {
      addToast({ message: "Please enter the Job Profile", status: "warning" });
      return;
    }

    if (isEditMode) {
      const response = await fetchApi(`Hrlense_JobProfile/${currentJobProfile.id}`, 'PUT', { id: currentJobProfile.id, jobProfile: currentJobProfile.jobProfile, departementName: currentJobProfile.departementName, departmentId: currentJobProfile.departmentId, status: currentJobProfile.status }, null, "JobProfile updated successfully");
      if (response) setEmployees((prev) => prev.map((industryType) => (industryType.id === selectedId ? currentJobProfile : industryType)));
    } else {
      const response = await fetchApi<IJobProfile>('Hrlense_JobProfile', 'POST', { jobProfile: currentJobProfile.jobProfile, departementName: currentJobProfile.departementName, departmentId: currentJobProfile.departmentId, status: currentJobProfile.status }, null, "JobProfile added successfully");

      if (response) setEmployees((prev) => [...prev, response]);
    }
    setDrawerOpen(false);
  };

  const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
          </Center>) : (
          <>
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_semibold text_3xl">Job Profile Master</Text>
              <Flex gap={2}>
                <InputGroup width="197px" height="37px">
                  <InputLeftElement pointerEvents="none">
                    <Search2Icon color="rgba(102, 112, 133, 1)" />
                  </InputLeftElement>
                  <Input type="text" className="font-poppins text_regular text_md" placeholder="Search by Job-Profile...." maxW="500px" />
                </InputGroup>
                <CustomButton title="Add New Job Profile" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={addIcon} className="logo" />} onClick={handleAddNewJobProfile} />
              </Flex>
            </Flex>
            <Grid className="grid_container">
              <GridItem colSpan={12}>
                <CustomTable value={employees} >
                  <Column header="S. No" body={(_, index) => index + 1} />
                  <Column header="Job Profile" field="jobProfile" />
                  <Column header="Department Name" field="departementName" />
                  <Column
                    header="Status"
                    body={(row: any) => (
                      <Select value={row.status ? "true" : "false"} 
                        onChange={(e) => handleStatusChange(row.id, e.target.value === "true")}
                        width="120px"
                        height="32px"
                        icon={<ChevronDownIcon />}
                        borderRadius="4px"
                        color={getStatusColor(row.status)}
                        className="font-poppins text_medium text_xsm"
                      >
                        <option value="true" style={{ color: "#38A169" }}>Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    )}
                  />

                  <Column<any>
                    header="Actions"
                    body={(row: any) => (<ActionEditIcon onClick={() => handleEditJobProfile(row)} />
                    )}
                  />
                </CustomTable>

              </GridItem>
            </Grid>
            <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />
            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit Job Profile" : "Add New Job Profile"}</DrawerHeader>
                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                  <Box py={4}>
                    <FormControl mb={4} isRequired>
                      <FormLabel>Job Profile</FormLabel>
                      <Input name="jobProfile" value={currentJobProfile.jobProfile} onChange={handleInputChange} placeholder="US IT Recruiter" />
                    </FormControl>
                    <FormControl mb={4}>
                      <FormLabel>Department</FormLabel>
                      <Select
                        name="departmentId"
                        value={currentJobProfile.departmentId}
                        onChange={handleDepartmentChange}
                        placeholder="Select Department"
                      >
                        {departments.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.departmentName}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl mb={4}>
                      <FormLabel>Status</FormLabel>
                      <Select w="120px" value={currentJobProfile.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentJobProfile.status)}>
                        <option value="true" style={{ color: "#38A169" }}> Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Flex justify="flex-end" mt={4} gap={2}>
                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}>Cancel</Button>
                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }}>{isEditMode ? "Update Job Profile" : "Add New Job Profile"}</Button>
                  </Flex>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </>)}
      </Box>
    </MyDiv>
  );
};
export default JobProfile;
